export default {
  SET_SELECTED_COUNTRY: (state, payload) => {
    state.selectedCountry = payload;
  }
};


// WEBPACK FOOTER //
// ./src/store/countries/mutations.js